/* Föderation list — aligned 1:1 to .design-ref/pim-admin/index.html (.tbl__*, code.codepill) */

.cellMain {
  display: flex;
  align-items: center;
  gap: 11px;
  min-width: 0;
}

.name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 220px;
}

.sub {
  font-size: var(--font-size-s);
  color: var(--color-grey);
  margin-top: 1px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 220px;
}

.subIssuer {
  font-size: var(--font-size-s);
  color: var(--color-grey);
  margin-top: 3px;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 240px;
}

.textSm {
  font-size: var(--font-size-m);
}

.codepill {
  background: var(--color-grey-lightest);
  padding: 2px 7px;
  border-radius: 5px;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: var(--font-size-s);
  font-weight: 400;
}
